import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxSplatNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* 중앙 큰 점 */}
      <circle cx="12" cy="12" r="3.5" fill={color} />

      {/* 상단 중간 점 */}
      <circle cx="12" cy="5" r="2" fill={color} opacity="0.8" />

      {/* 하단 중간 점 */}
      <circle cx="12" cy="19" r="2" fill={color} opacity="0.8" />

      {/* 좌측 중간 점 */}
      <circle cx="5" cy="12" r="2" fill={color} opacity="0.8" />

      {/* 우측 중간 점 */}
      <circle cx="19" cy="12" r="2" fill={color} opacity="0.8" />

      {/* 좌상단 작은 점 */}
      <circle cx="7" cy="7" r="1.2" fill={color} opacity="0.6" />

      {/* 우상단 작은 점 */}
      <circle cx="17" cy="7" r="1.2" fill={color} opacity="0.6" />

      {/* 좌하단 작은 점 */}
      <circle cx="7" cy="17" r="1.2" fill={color} opacity="0.6" />

      {/* 우하단 작은 점 */}
      <circle cx="17" cy="17" r="1.2" fill={color} opacity="0.6" />
    </BaseIcon>
  ),
);

ToolboxSplatNsk.displayName = 'ToolboxSplatNsk';
